import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import ToastDialog from "../dialogs/ToastDialog/toast";
import BottomNavbar from "../other-components/BottomNavbar/Navbar";
import DialogConfirm from "../dialogs/DialogConfirm/dialog";
import { openNewPage, copyText, AVATARS_ARR } from "../modals/Constants";
import { getStorage, deleteStorage } from "../modals/Storage";
import general from "../css/General.module.css";

function Account() {
  const toastDialogRef = useRef(null);
  const dialogConfirmRef = useRef(null);

  const navigate = useNavigate();
  const signOutAccount = () => {
    if (deleteStorage()) {
      navigate("/login", { replace: true, state: { fromSignOut: true } });
    }
  };

  // toast component
  const onToastChange = (data, msg) => { };

  const showToast = (message, duration, delay, mode) => {
    toastDialogRef.current.openDialog(message, duration, delay, mode);
  };

  // dialog confrim component
  const onDialogConfirm = (data, msg) => {
    signOutAccount();
  };

  const showDialogConfirm = (message, delay, mode) => {
    dialogConfirmRef.current.openDialog(message, delay, mode);
  };

  const copyMyId = () => {
    copyText(getStorage("uid"));
    showToast("ID Copied!", 2500, 0, 1);
  };

  useEffect(() => {
    if (!getStorage("uid")) {
      signOutAccount();
    }
  }, []);

  return (
    <div className={[general.appContents].join(" ")}>
      <DialogConfirm onConfirmed={onDialogConfirm} ref={dialogConfirmRef} />
      <ToastDialog onToastChange={onToastChange} ref={toastDialogRef} />

      <div
        className={[
          general.height100vh,
          general.respWidth,
          general.overflowScrollY,
          general.hideScrollBar,
        ].join(" ")}
      >
        <div className="col-view pd-15">
          <div className="row-view">
            <div
              className="h-w-70 ovf-hidden br-50"
              onClick={() => navigate("/updateaccount", { replace: false })}
            >
              {getStorage("avatarId") ? (
                <img
                  src={
                    AVATARS_ARR[Number(getStorage("avatarId")) - 1]["avatarURL"]
                  }
                  className="h-w-70"
                  alt="icon"
                />
              ) : (
                ""
              )}
            </div>

            <div className="col-view mg-l-15">
              <Link className="row-view txt-deco-n" to={"/changename"}>
                <div className="cl-white ft-wgt-500 ft-sz-1p25rem">
                  {getStorage("uname")}
                </div>
                <img
                  src={require(`../media/icons/angle_right_white_icon.png`)}
                  className="w-15-p mg-l-10"
                  alt="icon"
                />
              </Link>

              <div
                className="cl-white ft-sz-14 mg-t-5"
                onClick={() => copyMyId()}
              >
                UID &nbsp; | &nbsp; {getStorage("uid")}
                <img
                  src={require("../media//icons/copy_icon.png")}
                  className="h-10-p mg-l-15"
                  alt="icon"
                />
              </div>
              <div className="cl-l-white-2 ft-sz-14 mg-t-5">
                Last Active: {getStorage("accountLastActive")}
              </div>
            </div>
          </div>

          <div className="w-100 col-view pd-15 mg-t-20 br-5 bg-custom-1 z-i-1">

            <div
              className={[
                general.rowView,
                general.spaceBetween,
                general.pd10px15px,
              ].join(" ")}
            >
              <div className="col-view">
                <span className="cl-l-white-2">Wallet</span>
                <span className="cl-white ft-sz-22">
                  ₹{Number(getStorage("balance")).toLocaleString()}
                </span>
              </div>

              <div className="col-view">
                <span className="cl-l-white-2">Profit</span>
                <span className="cl-white ft-sz-22">
                  ₹{Number(getStorage("wbalance")).toLocaleString()}
                </span>
              </div>
            </div>

            <div className="line-hv-grey mg-t-10"></div>

            <div
              className={[
                general.rowView,
                general.spaceBetween,
                general.pd10px15px,
              ].join(" ")}
            >
              <Link
                className={[
                  general.textDecoNone,
                  general.colView,
                  general.viewCenter,
                ].join(" ")}
                to={"/recharge"}
              >
                <img
                  src={require("../media/icons/deposit_icon.png")}
                  className="h-w-28"
                  alt="icon"
                />
                <span className="cl-l-white">
                  Deposit
                </span>
              </Link>

              <Link
                className={[
                  general.textDecoNone,
                  general.colView,
                  general.viewCenter,
                ].join(" ")}
                to={"/withdraw"}
              >
                <img
                  src={require("../media/icons/withdrawl_icon.png")}
                  className="h-w-28"
                  alt="icon"
                />
                <span className="cl-l-white">
                  Withdraw
                </span>
              </Link>

              <div
                className={[general.colView, general.viewCenter].join(" ")}
                onClick={() => openNewPage(getStorage("appDownloadURL"))}
              >
                <img
                  src={require("../media/icons/download_icon.png")}
                  className="h-w-28"
                  alt="icon"
                />
                <span className="cl-l-white">
                  Download
                </span>
              </div>
            </div>
          </div>

          <div className="mg-t-15 mg-b-10em br-5 bg-custom-1">
            <Link className="txt-deco-n row-view sb-view pd-15" to={"/helpsupport"}>
              <div className="row-view">
                <img
                  src={require("../media/icons/help_support_icon.png")}
                  className="w-25-p"
                  alt="icon"
                />
                <span className="cl-white mg-l-10">Help & Support</span>
              </div>

              <img
                src={require("../media/icons/angle_right_white_icon.png")}
                className="w-15-p"
                alt="icon"
              />
            </Link>

            <Link className="txt-deco-n row-view sb-view pd-15" to={"/traderecords"}>
              <div className="row-view">
                <img
                  src={require("../media/icons/history_icon.png")}
                  className="w-25-p"
                  alt="icon"
                />
                <span className="cl-white mg-l-10">Trade History</span>
              </div>

              <img
                src={require("../media/icons/angle_right_white_icon.png")}
                className="w-15-p"
                alt="icon"
              />
            </Link>

            <Link className="txt-deco-n row-view sb-view pd-15" to={"/rechargerecords"}>
              <div className="row-view">
                <img
                  src={require("../media/icons/help_support_icon.png")}
                  className="w-25-p"
                  alt="icon"
                />
                <span className="cl-white mg-l-10">Deposit History</span>
              </div>

              <img
                src={require("../media/icons/angle_right_white_icon.png")}
                className="w-15-p"
                alt="icon"
              />
            </Link>

            <Link className="txt-deco-n row-view sb-view pd-15" to={"/withdrawrecords"}>
              <div className="row-view">
                <img
                  src={require("../media/icons/help_support_icon.png")}
                  className="w-25-p"
                  alt="icon"
                />
                <span className="cl-white mg-l-10">Withdrawal History</span>
              </div>

              <img
                src={require("../media/icons/angle_right_white_icon.png")}
                className="w-15-p"
                alt="icon"
              />
            </Link>

            <Link className="txt-deco-n row-view sb-view pd-15" to={"/transactions"}>
              <div className="row-view">
                <img
                  src={require("../media/icons/help_support_icon.png")}
                  className="w-25-p"
                  alt="icon"
                />
                <span className="cl-white mg-l-10">Transactions History</span>
              </div>

              <img
                src={require("../media/icons/angle_right_white_icon.png")}
                className="w-15-p"
                alt="icon"
              />
            </Link>

            <Link className="txt-deco-n row-view sb-view pd-15">
              <div className="row-view">
                <img
                  src={require("../media/icons/download_icon_white.png")}
                  className="w-25-p"
                  alt="icon"
                />
                <span className="cl-white mg-l-10">Download App</span>
              </div>

              <img
                src={require("../media/icons/angle_right_white_icon.png")}
                className="w-15-p"
                alt="icon"
              />
            </Link>

            <div className="pd-10">
              <div className="v-center ft-sz-20 pd-10-15 cl-white mg-t-20 br-5 bg-selected" onClick={() => showDialogConfirm("Are you sure you want to logout?")}>Sign Out</div>
            </div>
          </div>
        </div>

        <BottomNavbar activeBar="account" />
      </div>
    </div>
  );
}

export default Account;
